import Splide from '@splidejs/splide';

export default (): void => {
  // const testimonials = document.querySelector('.ecodigo-testimonials') as HTMLElement | null;
  const partners = document.querySelector('.ecodigo-partners.--is-slider') as HTMLElement | null;
  // const featuredPosts = document.querySelector('.ecodigo-featured-posts') as HTMLElement | null;

  const defaultSplideOptions = {
    perPage: 3,
    perMove: 1,
    type: 'loop',
    pagination: false,
    gap: '1.5rem',
  };

  // if (testimonials) {
  //   // Instantiate Testimonials slider
  //   new Splide(testimonials, {
  //     ...defaultSplideOptions,
  //     pagination: true,
  //     breakpoints: {
  //       1198: {
  //         perPage: 2,
  //       },
  //       992: {
  //         perPage: 1,
  //       },
  //     },
  //   }).mount();
  // }

  if (partners) {
    // Instantiate Partners slider
    new Splide(partners, {
      ...defaultSplideOptions,
      perPage: 7,
      gap: '3rem',
      breakpoints: {
        1198: {
          perPage: 5,
        },
        992: {
          perPage: 3,
        },
        767: {
          perPage: 2,
        },
        485: {
          perPage: 1,
        },
      },
    }).mount();
  }

  // if (featuredPosts) {
  //   // Instantiate Featured Posts slider
  //   new Splide(featuredPosts, {
  //     ...defaultSplideOptions,
  //     type: 'slide',
  //     arrows: false,
  //     pagination: true,
  //     breakpoints: {
  //       1198: {
  //         perPage: 2,
  //       },
  //       992: {
  //         perPage: 1,
  //       },
  //     },
  //   }).mount();
  // }
};
